import { render, staticRenderFns } from "./district.vue?vue&type=template&id=5b8e8600"
import script from "./district.vue?vue&type=script&lang=ts"
export * from "./district.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports